module.exports = __webpack_public_path__ + "01_short_black.e33f2bc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/01_short_black.png
// module id = 4Od5
// module chunks = 0